var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.submitting,
          expression: "submitting",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      staticClass: "modify-supplement-create",
      attrs: { "element-loading-text": "提交中..." },
    },
    [
      _c(
        "el-card",
        { attrs: { "body-style": { padding: "12px 16px" } } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              staticStyle: { padding: "8px 16px" },
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "title" }, [_vm._v("发起改补")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right", padding: "3px 0" },
                  attrs: { type: "text" },
                  on: { click: _vm.goBack },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "createForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _vm.selectedContract
                ? _c("div", { staticClass: "form-section" }, [
                    _c(
                      "div",
                      {
                        staticClass: "section-title",
                        staticStyle: {
                          color: "#303133",
                          "border-left-color": "#303133",
                        },
                      },
                      [_vm._v("原单信息")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-wrap": "wrap",
                          gap: "12px 0",
                          padding: "4px 0",
                          "font-size": "13px",
                        },
                      },
                      [
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("合同号："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.selectedContract.contractNo || "-")
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("销售单号："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.selectedContract.productionOrder || "-"
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("客户姓名："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.selectedContract.custName || "-")
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("客户电话："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.selectedContract.custMobile || "-")
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("客户地址："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.selectedContract.custAddress || "-")
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("省市区："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                (_vm.selectedContract.province || "") +
                                  (_vm.selectedContract.city || "") +
                                  (_vm.selectedContract.district || "") || "-"
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("下单人："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.parseNickName(
                                  _vm.selectedContract.orderClerkNickName
                                ) || "-"
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("设计师："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.parseNickName(
                                  _vm.selectedContract.designerNickName
                                ) || "-"
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("导购："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.parseNickName(
                                  _vm.selectedContract.guideNickName
                                ) || "-"
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { width: "25%" } },
                          [
                            _c("span", { staticStyle: { color: "#606266" } }, [
                              _vm._v("经销商："),
                            ]),
                            _vm._v(" "),
                            _vm.canSelectDealerShop
                              ? [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "180px" },
                                      attrs: {
                                        placeholder: "请选择经销商",
                                        size: "small",
                                        filterable: "",
                                      },
                                      model: {
                                        value: _vm.selectedDealerCode,
                                        callback: function ($$v) {
                                          _vm.selectedDealerCode = $$v
                                        },
                                        expression: "selectedDealerCode",
                                      },
                                    },
                                    _vm._l(_vm.dealerList, function (dealer) {
                                      return _c("el-option", {
                                        key: dealer.code || dealer.name,
                                        attrs: {
                                          label: dealer.name,
                                          value: dealer.code || dealer.name,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.selectedDealerCode
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#f56c6c",
                                            "margin-left": "4px",
                                            "font-size": "12px",
                                          },
                                        },
                                        [_vm._v("必填")]
                                      )
                                    : _vm._e(),
                                ]
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.selectedContract.dealer || "-")
                                  ),
                                ]),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { width: "25%" } },
                          [
                            _c("span", { staticStyle: { color: "#606266" } }, [
                              _vm._v("门店："),
                            ]),
                            _vm._v(" "),
                            _vm.canSelectDealerShop || _vm.isOldOrderData
                              ? [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "180px" },
                                      attrs: {
                                        disabled:
                                          _vm.canSelectDealerShop &&
                                          !_vm.selectedDealerCode,
                                        placeholder: "请选择门店",
                                        size: "small",
                                        filterable: "",
                                      },
                                      model: {
                                        value: _vm.selectedDealerShopCode,
                                        callback: function ($$v) {
                                          _vm.selectedDealerShopCode = $$v
                                        },
                                        expression: "selectedDealerShopCode",
                                      },
                                    },
                                    _vm._l(_vm.dealerShopList, function (shop) {
                                      return _c("el-option", {
                                        key: shop.shopNo,
                                        attrs: {
                                          label: shop.shopName,
                                          value: shop.shopNo,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.selectedDealerShopCode
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#f56c6c",
                                            "margin-left": "4px",
                                            "font-size": "12px",
                                          },
                                        },
                                        [_vm._v("必填")]
                                      )
                                    : _vm._e(),
                                ]
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.selectedContract.dealerShopName || "-"
                                    )
                                  ),
                                ]),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("渠道类型："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.selectedContract.msgFrom ||
                                  _vm.selectedContract.channelType ||
                                  "-"
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("安装主管："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.selectedContract.installMamager || "-")
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("安装组长："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.selectedContract.installGroup || "-")
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("安装技术员："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.selectedContract.installPerson || "-")
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("完工日期："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.selectedContract.installFinishTime ||
                                  _vm.selectedContract.actualFinishingDate ||
                                  "-"
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "25%" } }, [
                          _c("span", { staticStyle: { color: "#606266" } }, [
                            _vm._v("创建时间："),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.selectedContract.createdatetime || "-")
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("改补信息"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 12 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "原合同号", prop: "contractId" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    gap: "8px",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "请选择合同",
                                      readonly: "",
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        _vm.showContractDialog = true
                                      },
                                    },
                                    model: {
                                      value: _vm.form.contractNoDisplay,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "contractNoDisplay",
                                          $$v
                                        )
                                      },
                                      expression: "form.contractNoDisplay",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-button", {
                                    attrs: {
                                      type: "primary",
                                      icon: "el-icon-search",
                                      disabled: _vm.submitted,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.showContractDialog = true
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "改补类型", prop: "modifyType" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择",
                                    disabled: _vm.submitted,
                                  },
                                  model: {
                                    value: _vm.form.modifyType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "modifyType", $$v)
                                    },
                                    expression: "form.modifyType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "改单", value: "改单" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "补单",
                                      value: "补单",
                                      disabled: _vm.isHistoryOrder,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: ["material:add"],
                                        expression: "['material:add']",
                                      },
                                    ],
                                    attrs: {
                                      label: "新增物料",
                                      value: "新增物料",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 12 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系人" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入联系人",
                                  disabled: _vm.submitted,
                                },
                                model: {
                                  value: _vm.form.contactPerson,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "contactPerson", $$v)
                                  },
                                  expression: "form.contactPerson",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系电话" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入联系电话",
                                  disabled: _vm.submitted,
                                },
                                model: {
                                  value: _vm.form.contactNumber,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "contactNumber", $$v)
                                  },
                                  expression: "form.contactNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系地址" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入联系地址",
                                  disabled: _vm.submitted,
                                },
                                model: {
                                  value: _vm.form.contactAddress,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "contactAddress", $$v)
                                  },
                                  expression: "form.contactAddress",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 12 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "问题原因",
                                prop: "problemCause",
                                required: _vm.form.modifyType !== "新增物料",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  placeholder: "请输入问题原因",
                                  rows: "2",
                                  maxlength: "500",
                                  "show-word-limit": "",
                                  disabled: _vm.submitted,
                                },
                                model: {
                                  value: _vm.form.problemCause,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "problemCause", $$v)
                                  },
                                  expression: "form.problemCause",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "问题现状",
                                prop: "problemNow",
                                required: _vm.form.modifyType !== "新增物料",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择问题现状",
                                    disabled: _vm.submitted,
                                  },
                                  model: {
                                    value: _vm.form.problemNow,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "problemNow", $$v)
                                    },
                                    expression: "form.problemNow",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "现场单", value: "现场单" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "售后单", value: "售后单" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "厂内改", value: "厂内改" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "正单遗留单",
                                      value: "正单遗留单",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 12 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _vm.form.modifyType !== "新增物料"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "问题图片",
                                    prop: "problemImg",
                                  },
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      attrs: {
                                        action: _vm.filesUploadApi,
                                        "http-request": function (options) {
                                          return _vm.uploadFileToOss(
                                            "problemImg",
                                            options
                                          )
                                        },
                                        headers: _vm.headers,
                                        "on-success": function (
                                          res,
                                          file,
                                          fileList
                                        ) {
                                          return _vm.handleUploadSuccess(
                                            "problemImg",
                                            res,
                                            file,
                                            fileList
                                          )
                                        },
                                        "on-remove": function (file) {
                                          return _vm.handleUploadRemove(
                                            "problemImg",
                                            file
                                          )
                                        },
                                        "before-upload": _vm.handleBeforeUpload,
                                        accept: "image/*",
                                        multiple: "",
                                        "file-list": _vm.problemImgUploadList,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary",
                                            disabled: _vm.submitted,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-upload",
                                          }),
                                          _vm._v(" 上传问题图片"),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.modifyType !== "新增物料"
                        ? _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "附件" } },
                                [
                                  _c("oss-upload", {
                                    ref: "fileUploadRef",
                                    attrs: {
                                      "upload-type": "file",
                                      multiple: true,
                                      "max-size": 100,
                                      accept:
                                        ".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.gif,.zip,.rar,.7z,.txt,.csv",
                                      "oss-dir": "crm/modifySupplement/file/",
                                    },
                                    on: {
                                      "upload-success":
                                        _vm.handleOssFileUploadSuccess,
                                      "delete-success":
                                        _vm.handleOssFileDeleteSuccess,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.modifyType === "新增物料"
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 12 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "物料附件" } },
                                [
                                  !_vm.form.contractId
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            color: "#f56c6c",
                                            "font-size": "12px",
                                            "line-height": "1.6",
                                            "margin-bottom": "8px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                请先选择原合同，再上传物料附件\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "small",
                                        type: "primary",
                                        disabled: _vm.submitted,
                                      },
                                      on: { click: _vm.openOtherFileDialog },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-upload",
                                      }),
                                      _vm._v(" 上传物料附件"),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.otherFileUploadList,
                                    function (file, idx) {
                                      return _c(
                                        "div",
                                        {
                                          key: file.uid,
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            width: "100%",
                                            padding: "2px 0",
                                            "font-size": "12px",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                flex: "1",
                                                overflow: "hidden",
                                                "text-overflow": "ellipsis",
                                                "white-space": "nowrap",
                                              },
                                              attrs: { title: file.name },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-paperclip",
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(file.name) +
                                                  "\n                  "
                                              ),
                                              file.productionOrder
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "4px",
                                                      },
                                                      attrs: {
                                                        size: "mini",
                                                        type: "info",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          file.productionOrder
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          !_vm.submitted
                                            ? _c("el-button", {
                                                staticStyle: {
                                                  "margin-left": "4px",
                                                },
                                                attrs: {
                                                  type: "text",
                                                  size: "mini",
                                                  icon: "el-icon-delete",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleUploadRemove(
                                                      "otherFile",
                                                      file
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 12 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "期望到货日期",
                                prop: "requiredDeliveryDate",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "请选择期望到货日期",
                                  "value-format": "yyyy-MM-dd",
                                  disabled: _vm.submitted,
                                },
                                model: {
                                  value: _vm.form.requiredDeliveryDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "requiredDeliveryDate",
                                      $$v
                                    )
                                  },
                                  expression: "form.requiredDeliveryDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: "3",
                                  placeholder: "请输入备注",
                                  maxlength: "500",
                                  "show-word-limit": "",
                                  disabled: _vm.submitted,
                                },
                                model: {
                                  value: _vm.form.problemDescription,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "problemDescription",
                                      $$v
                                    )
                                  },
                                  expression: "form.problemDescription",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.modifyType === "补单" ||
                  _vm.form.modifyType === "新增物料"
                    ? [
                        _c(
                          "el-row",
                          { attrs: { gutter: 12 } },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { span: 16 },
                              },
                              [
                                _vm.form.modifyType !== "新增物料"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          icon: "el-icon-document-copy",
                                          disabled: _vm.submitted,
                                        },
                                        on: {
                                          click: _vm.selectOriginalMaterials,
                                        },
                                      },
                                      [_vm._v("选择原单物料")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.form.modifyType !== "补单"
                                  ? _c(
                                      "el-button",
                                      {
                                        staticStyle: { "margin-left": "12px" },
                                        attrs: {
                                          type: "success",
                                          icon: "el-icon-plus",
                                          disabled: _vm.submitted,
                                        },
                                        on: { click: _vm.selectOtherMaterials },
                                      },
                                      [_vm._v("选择其它物料")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(
                          _vm.groupsWithMaterials,
                          function (group, gIndex) {
                            return _c(
                              "el-row",
                              {
                                key: group.audit.id || group.audit.rowId,
                                attrs: { gutter: 12 },
                              },
                              [
                                _c("el-col", { attrs: { span: 22 } }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "14px",
                                        "font-weight": "bold",
                                        color: "#303133",
                                        margin: "12px 0 6px",
                                        "padding-left": "8px",
                                        "border-left": "3px solid #409EFF",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              原单号：" +
                                          _vm._s(
                                            group.audit.productionOrder || "-"
                                          ) +
                                          "\n              "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#909399",
                                            "font-weight": "normal",
                                            "margin-left": "16px",
                                          },
                                        },
                                        [_vm._v("产品名称：")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#303133",
                                            "font-weight": "normal",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(group.audit.auditName || "-")
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  group.materials.length > 0
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                color: "#409EFF",
                                                margin: "6px 0 4px",
                                              },
                                            },
                                            [_vm._v("原单物料")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table",
                                            {
                                              staticStyle: {
                                                "margin-top": "4px",
                                              },
                                              attrs: {
                                                data: group.materials,
                                                size: "mini",
                                                border: "",
                                                "max-height": "280",
                                              },
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  type: "index",
                                                  label: "序号",
                                                  width: "50",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "barcode",
                                                  label: "部件编码",
                                                  "min-width": "130",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "code",
                                                  label: "编码",
                                                  "min-width": "110",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "name",
                                                  label: "物料名称",
                                                  "min-width": "140",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "solutionName",
                                                  label: "生产分类",
                                                  "min-width": "100",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "length",
                                                  label: "长",
                                                  width: "70",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .length || "-"
                                                            )
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "width",
                                                  label: "宽",
                                                  width: "70",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row.width ||
                                                                "-"
                                                            )
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "height",
                                                  label: "高",
                                                  width: "70",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .height || "-"
                                                            )
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "数量",
                                                  width: "70",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c("el-input", {
                                                            attrs: {
                                                              size: "mini",
                                                              placeholder: "-",
                                                              disabled:
                                                                _vm.submitted,
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .quantity,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "quantity",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.quantity",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "操作",
                                                  width: "60",
                                                  fixed: "right",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          !_vm.submitted
                                                            ? _c("el-button", {
                                                                attrs: {
                                                                  type: "danger",
                                                                  size: "mini",
                                                                  icon: "el-icon-delete",
                                                                  circle: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeMaterial(
                                                                        gIndex,
                                                                        scope.$index
                                                                      )
                                                                    },
                                                                },
                                                              })
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  group.otherMaterials &&
                                  group.otherMaterials.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "12px" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                color: "#67C23A",
                                                margin: "6px 0 4px",
                                              },
                                            },
                                            [_vm._v("其它物料")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table",
                                            {
                                              attrs: {
                                                data: group.otherMaterials,
                                                size: "mini",
                                                border: "",
                                                "max-height": "280",
                                              },
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  type: "index",
                                                  label: "序号",
                                                  width: "50",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "code",
                                                  label: "编码",
                                                  "min-width": "150",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "name",
                                                  label: "物料名称",
                                                  "min-width": "160",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "size",
                                                  label: "规格",
                                                  "min-width": "100",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "unitName",
                                                  label: "单位",
                                                  "min-width": "60",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "categoryName",
                                                  label: "分类",
                                                  "min-width": "100",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "长",
                                                  width: "100",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c("el-input", {
                                                            attrs: {
                                                              size: "mini",
                                                              placeholder: "-",
                                                              disabled:
                                                                _vm.submitted,
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .length,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "length",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.length",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "宽",
                                                  width: "100",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c("el-input", {
                                                            attrs: {
                                                              size: "mini",
                                                              placeholder: "-",
                                                              disabled:
                                                                _vm.submitted,
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row.width,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "width",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.width",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "高",
                                                  width: "100",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c("el-input", {
                                                            attrs: {
                                                              size: "mini",
                                                              placeholder: "-",
                                                              disabled:
                                                                _vm.submitted,
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .height,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "height",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.height",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "数量",
                                                  width: "70",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c("el-input", {
                                                            attrs: {
                                                              size: "mini",
                                                              placeholder: "-",
                                                              disabled:
                                                                _vm.submitted,
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .quantity,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "quantity",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.quantity",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "操作",
                                                  width: "60",
                                                  fixed: "right",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          !_vm.submitted
                                                            ? _c("el-button", {
                                                                attrs: {
                                                                  type: "danger",
                                                                  size: "mini",
                                                                  icon: "el-icon-delete",
                                                                  circle: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeOtherMaterial(
                                                                        gIndex,
                                                                        scope.$index
                                                                      )
                                                                    },
                                                                },
                                                              })
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  group.otherFiles &&
                                  group.otherFiles.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "12px" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                color: "#E6A23C",
                                                margin: "6px 0 4px",
                                              },
                                            },
                                            [_vm._v("物料附件")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            group.otherFiles,
                                            function (f) {
                                              return _c(
                                                "div",
                                                {
                                                  key: f.uid,
                                                  staticStyle: {
                                                    display: "flex",
                                                    "align-items": "center",
                                                    padding: "2px 0",
                                                    "font-size": "13px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        flex: "1",
                                                        overflow: "hidden",
                                                        "text-overflow":
                                                          "ellipsis",
                                                        "white-space": "nowrap",
                                                      },
                                                      attrs: { title: f.name },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-paperclip",
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(f.name) +
                                                          "\n                "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  !_vm.submitted
                                                    ? _c("el-button", {
                                                        staticStyle: {
                                                          "margin-left": "4px",
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          size: "mini",
                                                          icon: "el-icon-delete",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeGroupOtherFile(
                                                              group,
                                                              f
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ]),
                              ],
                              1
                            )
                          }
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.submitted
                    ? _c(
                        "div",
                        {
                          staticClass: "form-footer",
                          staticStyle: { "margin-top": "16px" },
                        },
                        [
                          _c("el-button", { on: { click: _vm.goBack } }, [
                            _vm._v("取消"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.submitting,
                                disabled: _vm.submitting,
                              },
                              on: { click: _vm.handleSubmit },
                            },
                            [_vm._v("提交")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showOrderSection
        ? _c(
            "el-card",
            {
              staticStyle: { "margin-top": "8px", "margin-bottom": "50px" },
              attrs: { "body-style": { padding: "8px 16px" } },
            },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  staticStyle: { padding: "6px 16px", cursor: "pointer" },
                  attrs: { slot: "header" },
                  on: { click: _vm.toggleOrderSection },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "title" }, [_vm._v("酷家乐下单")]),
                  _vm._v(" "),
                  _c("i", {
                    class: _vm.orderSectionVisible
                      ? "el-icon-arrow-down"
                      : "el-icon-arrow-right",
                    staticStyle: {
                      float: "right",
                      "line-height": "28px",
                      color: "#909399",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.orderSectionVisible,
                        expression: "orderSectionVisible",
                      },
                    ],
                  },
                  [
                    _c("OrderSection", {
                      attrs: {
                        "contract-id":
                          _vm.newContractId ||
                          (_vm.selectedContract &&
                            (_vm.selectedContract.id ||
                              _vm.selectedContract.rowId)),
                        "contract-no":
                          _vm.newContractNo ||
                          (_vm.selectedContract &&
                            _vm.selectedContract.contractNo),
                        "source-contract-no":
                          _vm.selectedContract &&
                          _vm.selectedContract.contractNo,
                        "disable-auto-load": "",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择合同",
            visible: _vm.showContractDialog,
            width: "80%",
            top: "5vh",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showContractDialog = $event
            },
            open: _vm.loadContractTable,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "margin-bottom": "15px",
              },
            },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { flex: "none", "margin-bottom": "0" },
                  on: { "tab-click": _vm.handleContractDataSourceChange },
                  model: {
                    value: _vm.contractDataSource,
                    callback: function ($$v) {
                      _vm.contractDataSource = $$v
                    },
                    expression: "contractDataSource",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "新CRM订单", name: "new" },
                  }),
                  _vm._v(" "),
                  _c("el-tab-pane", {
                    attrs: { label: "Ishare订单", name: "old" },
                  }),
                  _vm._v(" "),
                  _c("el-tab-pane", {
                    attrs: { label: "改补订单", name: "modify" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.submitted
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "12px" },
                      attrs: {
                        type: "warning",
                        icon: "el-icon-document",
                        size: "small",
                      },
                      on: { click: _vm.openHistoryOrderFromContractDialog },
                    },
                    [_vm._v("历史订单")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "15px" } },
            [
              _c(
                "el-form",
                { attrs: { inline: true, size: "small" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "合同号" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.contractSearchForm.contractNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.contractSearchForm, "contractNo", $$v)
                          },
                          expression: "contractSearchForm.contractNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.contractDataSource === "new"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "生产单号" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "160px" },
                            attrs: { placeholder: "请输入", clearable: "" },
                            model: {
                              value: _vm.contractSearchForm.productionOrder,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.contractSearchForm,
                                  "productionOrder",
                                  $$v
                                )
                              },
                              expression: "contractSearchForm.productionOrder",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contractDataSource === "modify"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "原合同号" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "160px" },
                            attrs: { placeholder: "请输入", clearable: "" },
                            model: {
                              value: _vm.contractSearchForm.originalContractNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.contractSearchForm,
                                  "originalContractNo",
                                  $$v
                                )
                              },
                              expression:
                                "contractSearchForm.originalContractNo",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户名称" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.contractSearchForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.contractSearchForm, "name", $$v)
                          },
                          expression: "contractSearchForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户电话" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.contractSearchForm.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.contractSearchForm, "mobile", $$v)
                          },
                          expression: "contractSearchForm.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户地址" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.contractSearchForm.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.contractSearchForm, "address", $$v)
                          },
                          expression: "contractSearchForm.address",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleContractSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        { on: { click: _vm.handleContractSearchReset } },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.contractTableLoading,
                  expression: "contractTableLoading",
                },
              ],
            },
            [
              _c(
                "el-table",
                {
                  ref: "contractSelectTable",
                  staticStyle: {
                    width: "100%",
                    "font-size": "14px",
                    cursor: "pointer",
                  },
                  attrs: {
                    data: _vm.contractTableList,
                    "header-cell-style": {
                      backgroundColor: "#e8eaed",
                      color: "#333",
                      fontWeight: "bold",
                    },
                    border: "",
                    "row-key": "id",
                    "highlight-current-row": "",
                  },
                  on: { "row-click": _vm.handleContractTableRowClick },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "contractNo",
                      label: "合同编号",
                      "min-width": "160",
                    },
                  }),
                  _vm._v(" "),
                  _vm.contractDataSource !== "new"
                    ? _c("el-table-column", {
                        attrs: { label: "销售单号", "min-width": "140" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.salesOrderId ||
                                        scope.row.productionOrder ||
                                        "-"
                                    )
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2398478998
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contractDataSource === "modify"
                    ? _c("el-table-column", {
                        attrs: { label: "原合同号", "min-width": "140" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(scope.row.originalContractNo || "-")
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3627109370
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contractDataSource === "modify"
                    ? _c("el-table-column", {
                        attrs: { label: "改补类型", "min-width": "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(scope.row.amendmentType || "-")
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4100884889
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "客户姓名", "min-width": "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(_vm._s(scope.row.custName || "-"))]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "客户电话", "min-width": "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(_vm._s(scope.row.custMobile || "-"))]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "客户地址",
                      "min-width": "200",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(_vm._s(scope.row.custAddress || "-"))]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "创建时间", "min-width": "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(_vm._s(scope.row.createdatetime || "-")),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px", "text-align": "right" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.contractPage,
                  "page-size": _vm.contractPageSize,
                  layout: "total, prev, pager, next",
                  total: _vm.contractTotal,
                  small: "",
                },
                on: { "current-change": _vm.handleContractPageChange },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showContractDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.contractDataSource === "old"
                ? "选择物料"
                : _vm.showOriginalBomView
                ? "选择原单产品 - BOM物料"
                : "选择原单产品 - 选择订单",
            visible: _vm.showOriginalMaterialDialog,
            width: "75%",
            top: "5vh",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showOriginalMaterialDialog = $event
            },
            open: _vm.loadOriginalMaterialTable,
            close: _vm.handleOriginalMaterialDialogClose,
          },
        },
        [
          !_vm.showOriginalBomView
            ? [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.originalBomLoading,
                        expression: "originalBomLoading",
                      },
                    ],
                  },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "auditSelectTable",
                        staticStyle: {
                          width: "100%",
                          "font-size": "14px",
                          cursor: "pointer",
                        },
                        attrs: {
                          data: _vm.originalAuditList,
                          "header-cell-style": {
                            backgroundColor: "#e8eaed",
                            color: "#333",
                            fontWeight: "bold",
                          },
                          border: "",
                          "row-key": "id",
                          "highlight-current-row": "",
                        },
                        on: { "row-click": _vm.handleSelectAudit },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "productionOrder",
                            label: "订单号",
                            "min-width": "160",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "auditName",
                            label: "产品名称",
                            "min-width": "180",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "productionStatus",
                            label: "订单状态",
                            "min-width": "120",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.showOriginalMaterialDialog = false
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showOriginalBomView
            ? [
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "15px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "default",
                          icon: "el-icon-arrow-left",
                          size: "small",
                        },
                        on: { click: _vm.backToAuditList },
                      },
                      [_vm._v("返回订单列表")]
                    ),
                    _vm._v(" "),
                    _vm.dialogSelectedAudit
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "12px",
                              color: "#606266",
                            },
                          },
                          [
                            _vm._v(
                              "\n          当前订单：" +
                                _vm._s(
                                  _vm.dialogSelectedAudit.productionOrder || "-"
                                )
                            ),
                            _vm.dialogSelectedAudit.auditName
                              ? [
                                  _vm._v(
                                    " / " +
                                      _vm._s(
                                        _vm.dialogSelectedAudit.auditName || "-"
                                      )
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "15px" } },
                  [
                    _c(
                      "el-form",
                      { attrs: { inline: true, size: "small" } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "生产分类" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "160px" },
                              attrs: { placeholder: "请输入", clearable: "" },
                              model: {
                                value: _vm.originalMaterialSearch.solutionName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.originalMaterialSearch,
                                    "solutionName",
                                    $$v
                                  )
                                },
                                expression:
                                  "originalMaterialSearch.solutionName",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "部件编码" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "160px" },
                              attrs: { placeholder: "请输入", clearable: "" },
                              model: {
                                value: _vm.originalMaterialSearch.barcode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.originalMaterialSearch,
                                    "barcode",
                                    $$v
                                  )
                                },
                                expression: "originalMaterialSearch.barcode",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "部件名称" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "160px" },
                              attrs: { placeholder: "请输入", clearable: "" },
                              model: {
                                value: _vm.originalMaterialSearch.name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.originalMaterialSearch,
                                    "name",
                                    $$v
                                  )
                                },
                                expression: "originalMaterialSearch.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.handleOriginalMaterialSearch },
                              },
                              [_vm._v("搜索")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: _vm.handleOriginalMaterialSearchReset,
                                },
                              },
                              [_vm._v("重置")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.originalBomLoading,
                        expression: "originalBomLoading",
                      },
                    ],
                  },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "originalMaterialTable",
                        staticStyle: {
                          width: "100%",
                          "font-size": "14px",
                          cursor: "pointer",
                        },
                        attrs: {
                          data: _vm.originalMaterialList,
                          "header-cell-style": {
                            backgroundColor: "#e8eaed",
                            color: "#333",
                            fontWeight: "bold",
                          },
                          border: "",
                          "row-key": "id",
                        },
                        on: {
                          "selection-change":
                            _vm.handleOriginalMaterialSelectionChange,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "selection", width: "45" },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "solutionName",
                            label: "生产分类",
                            "min-width": "80",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "barcode",
                            label: "部件编码",
                            "min-width": "150",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: "部件名称",
                            "min-width": "150",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "code",
                            label: "物料编码",
                            "min-width": "130",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "material",
                            label: "材质",
                            "min-width": "120",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "color",
                            label: "颜色",
                            "min-width": "120",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "规格(长×宽×高)",
                            "min-width": "150",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(scope.row.length || "-") +
                                        "×" +
                                        _vm._s(scope.row.width || "-") +
                                        "×" +
                                        _vm._s(scope.row.height || "-") +
                                        "\n              "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            137194261
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "quantity",
                            label: "数量",
                            "min-width": "60",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "remark",
                            label: "备注",
                            "min-width": "120",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "10px",
                      "text-align": "right",
                    },
                  },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.originalMaterialPage,
                        "page-size": _vm.originalMaterialPageSize,
                        layout: "total, prev, pager, next",
                        total: _vm.originalMaterialTotal,
                        small: "",
                      },
                      on: {
                        "current-change": _vm.handleOriginalMaterialPageChange,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.showOriginalMaterialDialog = false
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled:
                            _vm.tempSelectedOriginalMaterials.length === 0,
                        },
                        on: { click: _vm.confirmOriginalMaterialSelect },
                      },
                      [
                        _vm._v(
                          "确定 (已选" +
                            _vm._s(_vm.tempSelectedOriginalMaterials.length) +
                            ")"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择其它物料",
            visible: _vm.showOtherMaterialDialog,
            width: "75%",
            top: "5vh",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showOtherMaterialDialog = $event
            },
            open: _vm.loadOtherMaterialTable,
          },
        },
        [
          _vm.contractDataSource !== "old"
            ? _c(
                "div",
                { staticStyle: { "margin-bottom": "12px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "default",
                        icon: "el-icon-arrow-left",
                        size: "small",
                      },
                      on: { click: _vm.backToOrderFromOtherMaterial },
                    },
                    [_vm._v("返回订单列表")]
                  ),
                  _vm._v(" "),
                  _vm.dialogSelectedAudit
                    ? _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "12px",
                            color: "#606266",
                          },
                        },
                        [
                          _vm._v(
                            "\n        当前订单：" +
                              _vm._s(
                                _vm.dialogSelectedAudit.productionOrder || "-"
                              ) +
                              " / " +
                              _vm._s(_vm.dialogSelectedAudit.auditName || "-") +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "15px" } },
            [
              _c(
                "el-form",
                { attrs: { inline: true, size: "small" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "物料名称" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        on: {
                          input: _vm.debouncedOtherMaterialSearch,
                          clear: _vm.handleOtherMaterialSearch,
                        },
                        model: {
                          value: _vm.otherMaterialSearch.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.otherMaterialSearch, "name", $$v)
                          },
                          expression: "otherMaterialSearch.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "编码" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        on: {
                          input: _vm.debouncedOtherMaterialSearch,
                          clear: _vm.handleOtherMaterialSearch,
                        },
                        model: {
                          value: _vm.otherMaterialSearch.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.otherMaterialSearch, "code", $$v)
                          },
                          expression: "otherMaterialSearch.code",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "分类" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        on: {
                          input: _vm.debouncedOtherMaterialSearch,
                          clear: _vm.handleOtherMaterialSearch,
                        },
                        model: {
                          value: _vm.otherMaterialSearch.categoryName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.otherMaterialSearch,
                              "categoryName",
                              $$v
                            )
                          },
                          expression: "otherMaterialSearch.categoryName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleOtherMaterialSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        { on: { click: _vm.handleOtherMaterialSearchReset } },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.otherMaterialLoading,
                  expression: "otherMaterialLoading",
                },
              ],
            },
            [
              _c(
                "el-table",
                {
                  ref: "otherMaterialTable",
                  staticStyle: {
                    width: "100%",
                    "font-size": "14px",
                    cursor: "pointer",
                  },
                  attrs: {
                    data: _vm.otherMaterialList,
                    "header-cell-style": {
                      backgroundColor: "#e8eaed",
                      color: "#333",
                      fontWeight: "bold",
                    },
                    border: "",
                    "row-key": "id",
                  },
                  on: {
                    "selection-change": _vm.handleOtherMaterialSelectionChange,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "45" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "code", label: "编码", "min-width": "150" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "物料名称",
                      "min-width": "160",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "size", label: "规格", "min-width": "120" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unitName",
                      label: "单位",
                      "min-width": "80",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "categoryName",
                      label: "分类",
                      "min-width": "120",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px", "text-align": "right" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.otherMaterialPage,
                  "page-size": _vm.otherMaterialPageSize,
                  layout: "total, prev, pager, next",
                  total: _vm.otherMaterialTotal,
                  small: "",
                },
                on: { "current-change": _vm.handleOtherMaterialPageChange },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showOtherMaterialDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.tempSelectedOtherMaterials.length === 0,
                  },
                  on: { click: _vm.confirmOtherMaterialSelect },
                },
                [
                  _vm._v(
                    "确定 (已选" +
                      _vm._s(_vm.tempSelectedOtherMaterials.length) +
                      ")"
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传物料附件",
            visible: _vm.showOtherFileDialog,
            width: "65%",
            top: "8vh",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showOtherFileDialog = $event
            },
            open: _vm.loadOtherFileAuditList,
            close: function ($event) {
              _vm.otherFileSelectedAudit = null
            },
          },
        },
        [
          !_vm.otherFileSelectedAudit
            ? [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "15px",
                      color: "#606266",
                      "font-size": "13px",
                    },
                  },
                  [_vm._v("\n        请先选择原单号，再上传物料附件\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.originalBomLoading,
                        expression: "originalBomLoading",
                      },
                    ],
                  },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: {
                          width: "100%",
                          "font-size": "14px",
                          cursor: "pointer",
                        },
                        attrs: {
                          data: _vm.originalAuditList,
                          "header-cell-style": {
                            backgroundColor: "#e8eaed",
                            color: "#333",
                            fontWeight: "bold",
                          },
                          border: "",
                          "row-key": "id",
                          "highlight-current-row": "",
                        },
                        on: { "row-click": _vm.handleOtherFileSelectAudit },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "productionOrder",
                            label: "订单号",
                            "min-width": "180",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "auditName",
                            label: "产品名称",
                            "min-width": "180",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "productionStatus",
                            label: "订单状态",
                            "min-width": "120",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.showOtherFileDialog = false
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.otherFileSelectedAudit
            ? [
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "15px" } },
                  [
                    !_vm.isHistoryOrder
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "default",
                              icon: "el-icon-arrow-left",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                _vm.otherFileSelectedAudit = null
                              },
                            },
                          },
                          [_vm._v("返回原单号列表")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-left": "12px",
                          color: "#606266",
                        },
                      },
                      [
                        _vm._v("\n          当前原单号："),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#303133",
                              "font-weight": "bold",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.otherFileSelectedAudit.productionOrder ||
                                  "-"
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.otherFileSelectedAudit.auditName
                          ? [
                              _vm._v(
                                " / " +
                                  _vm._s(_vm.otherFileSelectedAudit.auditName)
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-upload",
                  {
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      action: _vm.filesUploadApi,
                      "http-request": function (options) {
                        return _vm.uploadFileToOss("otherFile", options)
                      },
                      headers: _vm.headers,
                      "on-success": function (res, file, fileList) {
                        return _vm.handleUploadSuccess(
                          "otherFile",
                          res,
                          file,
                          fileList
                        )
                      },
                      "on-remove": function (file) {
                        return _vm.handleUploadRemove("otherFile", file)
                      },
                      "before-upload": _vm.handleOtherFileBeforeUpload,
                      multiple: "",
                      "show-file-list": false,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          type: "primary",
                          disabled: _vm.submitted,
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-upload" }),
                        _vm._v(" 上传物料附件"),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "el-upload__tip",
                        attrs: { slot: "tip" },
                        slot: "tip",
                      },
                      [
                        _vm._v(
                          "附件将归属到当前原单号：" +
                            _vm._s(
                              _vm.otherFileSelectedAudit.productionOrder || "-"
                            )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.otherFileListByOrder(
                  _vm.otherFileSelectedAudit.productionOrder
                ).length > 0
                  ? _c(
                      "div",
                      { staticStyle: { "margin-top": "12px" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#409EFF",
                              margin: "6px 0 4px",
                            },
                          },
                          [
                            _vm._v(
                              "已上传附件（" +
                                _vm._s(
                                  _vm.otherFileListByOrder(
                                    _vm.otherFileSelectedAudit.productionOrder
                                  ).length
                                ) +
                                "）"
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(
                          _vm.otherFileListByOrder(
                            _vm.otherFileSelectedAudit.productionOrder
                          ),
                          function (file) {
                            return _c(
                              "div",
                              {
                                key: file.uid,
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  width: "100%",
                                  padding: "2px 0",
                                  "font-size": "13px",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      flex: "1",
                                      overflow: "hidden",
                                      "text-overflow": "ellipsis",
                                      "white-space": "nowrap",
                                    },
                                    attrs: { title: file.name },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-paperclip",
                                    }),
                                    _vm._v(
                                      " " + _vm._s(file.name) + "\n          "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.submitted
                                  ? _c("el-button", {
                                      staticStyle: { "margin-left": "4px" },
                                      attrs: {
                                        type: "text",
                                        size: "mini",
                                        icon: "el-icon-delete",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleUploadRemove(
                                            "otherFile",
                                            file
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }
                        ),
                      ],
                      2
                    )
                  : _c(
                      "div",
                      {
                        staticStyle: {
                          color: "#909399",
                          "font-size": "13px",
                          padding: "12px 0",
                        },
                      },
                      [_vm._v("\n        暂无附件\n      ")]
                    ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.showOtherFileDialog = false
                          },
                        },
                      },
                      [_vm._v("关闭")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "历史订单",
            visible: _vm.showHistoryOrderDialog,
            width: "70%",
            top: "5vh",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showHistoryOrderDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "historyOrderForm",
              attrs: {
                model: _vm.historyOrderForm,
                rules: _vm.historyOrderRules,
                "label-width": "110px",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "合同号", prop: "contractNo" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入合同号" },
                            model: {
                              value: _vm.historyOrderForm.contractNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.historyOrderForm,
                                  "contractNo",
                                  $$v
                                )
                              },
                              expression: "historyOrderForm.contractNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "销售单号", prop: "productionOrder" },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入销售单号" },
                            model: {
                              value: _vm.historyOrderForm.productionOrder,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.historyOrderForm,
                                  "productionOrder",
                                  $$v
                                )
                              },
                              expression: "historyOrderForm.productionOrder",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户姓名", prop: "custName" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入客户姓名" },
                            model: {
                              value: _vm.historyOrderForm.custName,
                              callback: function ($$v) {
                                _vm.$set(_vm.historyOrderForm, "custName", $$v)
                              },
                              expression: "historyOrderForm.custName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户电话", prop: "custMobile" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入客户电话" },
                            model: {
                              value: _vm.historyOrderForm.custMobile,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.historyOrderForm,
                                  "custMobile",
                                  $$v
                                )
                              },
                              expression: "historyOrderForm.custMobile",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户地址", prop: "custAddress" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入客户地址" },
                            model: {
                              value: _vm.historyOrderForm.custAddress,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.historyOrderForm,
                                  "custAddress",
                                  $$v
                                )
                              },
                              expression: "historyOrderForm.custAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "省市区" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入省市区" },
                            model: {
                              value: _vm.historyOrderForm.region,
                              callback: function ($$v) {
                                _vm.$set(_vm.historyOrderForm, "region", $$v)
                              },
                              expression: "historyOrderForm.region",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "下单人" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入下单人" },
                            model: {
                              value: _vm.historyOrderForm.orderClerkNickName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.historyOrderForm,
                                  "orderClerkNickName",
                                  $$v
                                )
                              },
                              expression: "historyOrderForm.orderClerkNickName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "设计师" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入设计师" },
                            model: {
                              value: _vm.historyOrderForm.designerNickName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.historyOrderForm,
                                  "designerNickName",
                                  $$v
                                )
                              },
                              expression: "historyOrderForm.designerNickName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "导购" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入导购" },
                            model: {
                              value: _vm.historyOrderForm.guideNickName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.historyOrderForm,
                                  "guideNickName",
                                  $$v
                                )
                              },
                              expression: "historyOrderForm.guideNickName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "渠道类型" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入渠道类型" },
                            model: {
                              value: _vm.historyOrderForm.channelType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.historyOrderForm,
                                  "channelType",
                                  $$v
                                )
                              },
                              expression: "historyOrderForm.channelType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "安装主管" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入安装主管" },
                            model: {
                              value: _vm.historyOrderForm.installMamager,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.historyOrderForm,
                                  "installMamager",
                                  $$v
                                )
                              },
                              expression: "historyOrderForm.installMamager",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "安装组长" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入安装组长" },
                            model: {
                              value: _vm.historyOrderForm.installGroup,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.historyOrderForm,
                                  "installGroup",
                                  $$v
                                )
                              },
                              expression: "historyOrderForm.installGroup",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "安装技术员" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入安装技术员" },
                            model: {
                              value: _vm.historyOrderForm.installPerson,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.historyOrderForm,
                                  "installPerson",
                                  $$v
                                )
                              },
                              expression: "historyOrderForm.installPerson",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "完工日期" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入完工日期" },
                            model: {
                              value: _vm.historyOrderForm.installFinishTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.historyOrderForm,
                                  "installFinishTime",
                                  $$v
                                )
                              },
                              expression: "historyOrderForm.installFinishTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建时间" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入创建时间" },
                            model: {
                              value: _vm.historyOrderForm.createdatetime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.historyOrderForm,
                                  "createdatetime",
                                  $$v
                                )
                              },
                              expression: "historyOrderForm.createdatetime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showHistoryOrderDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmHistoryOrder },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }